export const omitKeys = <T extends object, K extends keyof T>(
  obj: T,
  keys: K[]
): Omit<T, K> =>
  Object.fromEntries(
    Object.entries(obj).filter(([k]) => !keys.includes(k as K))
  ) as Omit<T, K>;
